import React, {useCallback, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import FromFieldSelect from '../../../atoms/FromFieldSelect';
import FromFieldDate from '../../../atoms/FromFieldDate';
import {DataGrid, GridOverlay, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import {FormControl, InputLabel, MenuItem, Pagination, Select as MuiSelect} from '@mui/material';
import {getFilterNotIdentifiable, getFilterNotIdentifiableCSV, getPhyVeriMaster} from '../../../services/asset.service';
import * as CryptoJS from 'crypto-js';
import {Parser} from 'json2csv';
import {getDepartmentList} from '../../../services/user.service';
import Select from 'react-select';
import '../AssetInfo/AssetList.css';
import './Notidentifiablereport.css';
/* ─── Date Helper (unchanged) ─── */
function getFormattedDate(dateString) {
    if (dateString) {
        const dte   = new Date(dateString);
        const year  = dte.getFullYear();
        const month = (dte.getMonth() + 1).toString().padStart(2, '0');
        const day   = dte.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return null;
}

/* ─── Columns (unchanged) ─── */
const columns = [
    {field: 'tag', headerName: 'TAG Name', width: 250},
    {field: 'parent_tag', headerName: 'Parent TAG', width: 250},
    {
        field: 'value_of_asset', headerName: 'Value of Asset', width: 150,
        renderCell: (params) => <p>{parseFloat(params.row.value_of_asset).toFixed(2)}</p>
    },
    {
        field: 'total_cost_without_tax', headerName: 'Total Cost Without Tax', width: 180,
        renderCell: (params) => <p>{parseFloat(params.row.total_cost_without_tax).toFixed(2)}</p>
    },
    {field: 'nature_of_presence',        headerName: 'Nature of Presence',          width: 230},
    {field: 'company_name',              headerName: 'Company Name',                width: 350, hide: true},
    {field: 'division_name',             headerName: 'Division Name',               width: 350, hide: true},
    {field: 'method',                    headerName: 'Method',                      width: 130, hide: true},
    {
        field: 'last_verification_date', headerName: 'Last Verification Date', width: 130, hide: true,
        renderCell: (params) => <p>{getFormattedDate(params.row.last_verification_date)}</p>,
    },
    {field: 'last_verification_remarks', headerName: 'Last Verification remark',    width: 130, hide: true},
    {
        field: 'created_at', headerName: 'Verification Date', width: 130,
        renderCell: (params) => <p>{getFormattedDate(params.row.created_at)}</p>,
    },
];

/* ─── Toolbar / Loader (unchanged) ─── */
function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport 
                csvOptions={{
                    fileName: 'not_identifiable_list',
                }}
            />
        </GridToolbarContainer>
    );
}

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);

/* ════════════════════════════════════════════════════════════
   COMPONENT
   ════════════════════════════════════════════════════════════ */
const NotIdentifiableReport = () => {

    /* ─── All state (identical to original — zero changes) ─── */
    const [items,                    setItems]                    = useState([]);
    const [itemsCSV,                 setItemsCSV]                = useState([]);
    const [loading,                  setLoading]                  = useState(false);
    const [csvLoading,               setCsvLoading]               = useState(false);
    const [page,                     setPage]                     = useState(1);
    const [totalItems,               setTotalItems]               = useState(0);
    const [pageSize,                 setPageSize]                 = useState(10);
    const [pvMaster,                 setPvMaster]                 = useState([]);
    const [pvMasterTable,            setPvMasterTable]            = useState('');
    const [errMsg,                   setErrMsg]                   = useState('');
    const [filterAssets,             setFilterAssets]             = useState('');
    const [errFilterAssets,          setErrFilterAssets]          = useState(false);
    const [startDate,                setStartDate]                = useState('');
    const [ErrStartDate,             setErrStartDate]             = useState(false);
    const [endDate,                  setEndDate]                  = useState('');
    const [ErrEndDate,               setErrEndDate]               = useState(false);
    const [departments,              setDepartments]              = useState([]);
    const [loadingDepartments,       setLoadingDepartments]       = useState(false);
    const [selectedOwnershipOptions, setSelectedOwnershipOptions] = useState(null);
    const [ownershipId,              setOwnershipId]              = useState('');
    const [ErrOwnershipId,           setErrOwnershipId]           = useState('');

    /* ─── All logic (identical to original — zero changes) ─── */
    useEffect(() => {
        const fetchDepartments = async () => {
            setLoadingDepartments(true);
            try {
                const EncryptData = CryptoJS.AES.encrypt(
                    JSON.stringify({authToken: sessionStorage.getItem('LoggedInToken')}),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                ).toString();
                const res = await getDepartmentList({token: EncryptData});
                const departmentData = res?.data?.data || res?.data || res?.departments || res?.results || [];
                if (Array.isArray(departmentData) && departmentData.length > 0) {
                    setDepartments(departmentData);
                } else {
                    setDepartments([]);
                }
            } catch (error) {
                console.error('Error fetching departments:', error.message, error.response);
                setDepartments([]);
            } finally {
                setLoadingDepartments(false);
            }
        };
        fetchDepartments();
    }, []);

    const optionListOwnership =
        departments && Array.isArray(departments) && departments.length > 0
            ? departments.map((option) => ({
                value: option.id,
                label: option.department_name || `Department ${option.id || 'Unknown'}`,
            }))
            : [{value: 'no-data', label: 'No Departments Available'}];

    function handleOwnership(data) {
        setSelectedOwnershipOptions(data);
        setOwnershipId(data ? data.value : '');
        setErrOwnershipId('');
    }

    useEffect(() => {
        if (!ownershipId && selectedOwnershipOptions) {
            setErrOwnershipId('Please select a department');
        } else {
            setErrOwnershipId('');
        }
    }, [ownershipId, selectedOwnershipOptions]);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    const fetchPvMaster = async () => {
        setLoading(true);
        try {
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: {offset: 0, pageSize: 1000},
                    authToken: sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();
            const res = await getPhyVeriMaster({token: encryptedData});
            if (res?.data?.data?.length) setPvMaster(res.data.data);
        } catch (error) {
            console.error('Error fetching PV master:', error);
            setErrMsg(error.message || 'Error fetching PV master data');
        } finally {
            setLoading(false);
        }
    };

    const fetchFilteredData = async () => {
        setLoading(true);
        try {
            const offset = calculateOffset(page, pageSize);
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: {
                        offset, pageSize,
                        pv_table_no:      pvMasterTable,
                        filter_of_assets: filterAssets,
                        start_date:       getFormattedDate(startDate) || '',
                        end_date:         getFormattedDate(endDate)   || '',
                        ownership_id:     ownershipId || '',
                    },
                    authToken: sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();
            const res = await getFilterNotIdentifiable({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
                setTotalItems(0);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setErrMsg(error.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchPvMaster(); }, []);

    useEffect(() => {
        if (pvMasterTable) fetchFilteredData();
    }, [page, pageSize, pvMasterTable]);

    const handlePvMasterChange = (e) => { setPvMasterTable(e.target.value); };

    const handleFilter = async () => {
        if (pvMasterTable || ownershipId || startDate || endDate) {
            setErrMsg('');
            setErrOwnershipId('');
            setErrStartDate(false);
            setErrEndDate(false);
            setPage(1);
            await fetchFilteredData();
        } else {
            setErrMsg('Please select at least one filter: Physical Master Table, Department, Start Date, or End Date');
        }
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const handlePageChange = (event, value) => { setPage(value); };

    const fetchAssetsCSV = useCallback(async () => {
        setCsvLoading(true);
        try {
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: {
                        pv_table_no:      pvMasterTable,
                        filter_of_assets: filterAssets,
                        start_date:       getFormattedDate(startDate) || '',
                        end_date:         getFormattedDate(endDate)   || '',
                        ownership_id:     ownershipId || '',
                    },
                    authToken: sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();
            const resCSV = await getFilterNotIdentifiableCSV({token: encryptedData});
            if (resCSV?.data?.data?.length) setItemsCSV(resCSV.data.data);
        } catch (error) {
            console.error('Error fetching assets CSV:', error);
        } finally {
            setCsvLoading(false);
        }
    }, [pvMasterTable, filterAssets, startDate, endDate, ownershipId]);

    const handleExportToCSV = async () => { await fetchAssetsCSV(); };

    useEffect(() => { if (itemsCSV.length > 0) generateCSV(); }, [itemsCSV]);

    const generateCSV = () => {
        try {
            const filteredData = itemsCSV.filter((item) =>
                filterAssets ? item.nature_of_presence === filterAssets : true
            );
            const jsonData = filteredData.map((item) => ({
                tag:                          item.tag || '',
                parent_tag:                   item.parent_tag || '',
                value_of_asset:               parseFloat(item.value_of_asset).toFixed(2) || '',
                total_cost_without_tax:       parseFloat(item.total_cost_without_tax).toFixed(2) || '',
                nature_of_presence:           item.nature_of_presence || '',
                company_name:                 item.company_name || '',
                division_name:                item.division_name || '',
                method:                       item.method || '',
                last_verification_date:       item.last_verification_date ? getFormattedDate(item.last_verification_date) : '',
                last_verification_remarks:    item.last_verification_remarks || '',
                created_at:                   item.created_at ? getFormattedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv  = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
            const url  = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href  = url;
            link.setAttribute('download', 'Filtered_Not_Identifiable_Reports.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    /* ─── PV Master select options ─── */
    const pvMasterOptions = pvMaster.map((opt) => ({
        value: opt.id,
        label: opt.phy_varify_table_name,
    }));

    /* ════ RENDER ════ */
    return (
        <div className="al-page" id="nir-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="nir-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon" id="nir-header-icon">
                        <i className="bi bi-exclamation-diamond-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Not Identifiable Report</h5>
                        <p className="al-page-subtitle">Filter and export unidentifiable physical verification assets</p>
                    </div>
                </div>
                {!loading && totalItems > 0 && (
                    <div className="al-record-badge" id="nir-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ FILTER PANEL ══ */}
            <div className="al-filter-card" id="nir-filter-panel">
                <div className="al-filter-card-header" id="nir-filter-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-funnel-fill"/> Search &amp; Filter
                    </span>
                </div>
                <div className="al-filter-card-body" id="nir-filter-body">

                    {/* Error alert */}
                    {errMsg && (
                        <div className="al-alert al-alert-danger" id="nir-err-msg" style={{
                            display: 'flex', alignItems: 'center', gap: 8,
                            padding: '10px 14px', marginBottom: 16,
                            background: '#fff1f2', border: '1px solid #fecdd3',
                            borderRadius: 6, color: '#9f1239', fontSize: '0.82rem'
                        }}>
                            <i className="bi bi-exclamation-triangle-fill"/>
                            {errMsg}
                        </div>
                    )}

                    {/* Row 1: PV Master Table + Type of Assets */}
                    <div className="al-filter-grid" id="nir-filter-grid-row1">

                        <div className="al-filter-group" id="nir-field-pvmaster">
                            <label className="al-filter-label" htmlFor="nir-select-pvmaster">
                                <i className="bi bi-table"/> Physical Master Table
                                <span className="al-required-star">*</span>
                            </label>
                            <select
                                id="nir-select-pvmaster"
                                className="al-form-select"
                                onChange={handlePvMasterChange}
                                value={pvMasterTable}
                            >
                                <option value="">Select PV Master Table</option>
                                {pvMaster.length > 0
                                    ? pvMaster.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.phy_varify_table_name}
                                        </option>
                                    ))
                                    : <option value="" disabled>No Data</option>
                                }
                            </select>
                        </div>

                        <div className="al-filter-group" id="nir-field-filterassets">
                            <label className="al-filter-label" htmlFor="nir-select-filterassets">
                                <i className="bi bi-box-seam"/> Type of Assets
                            </label>
                            {/* FromFieldSelect kept intact — only wrapped in al-filter-group */}
                            <FromFieldSelect
                                label=""
                                placeholder="Type of Assets"
                                selectedValue={filterAssets}
                                setSelectedValue={setFilterAssets}
                                values={["Asset", "Consumable"]}
                                setErrorMsg={errFilterAssets}
                            />
                        </div>

                        {/* Apply Filter button aligned right */}
                        <div className="al-filter-group" id="nir-field-apply" style={{justifyContent: 'flex-end'}}>
                            <label className="al-filter-label" style={{visibility: 'hidden'}}>Action</label>
                            <button
                                id="nir-btn-filter"
                                className="al-btn al-btn-primary"
                                onClick={handleFilter}
                            >
                                <i className="bi bi-search"/> Apply Filter
                            </button>
                        </div>

                    </div>

                    {/* Actions row: Export */}
                    <div className="al-filter-actions" id="nir-filter-actions">
                        <button
                            id="nir-btn-export"
                            className="al-btn al-btn-outline"
                            onClick={handleExportToCSV}
                            disabled={csvLoading}
                        >
                            {csvLoading ? (
                                <><span className="al-dot"/><span className="al-dot"/><span className="al-dot"/> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-arrow-down"/> Export All Data to CSV</>
                            )}
                        </button>
                    </div>

                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="nir-grid-card">
                <div className="al-grid-card-header" id="nir-grid-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Not Identifiable Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge" id="nir-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box id="nir-grid-box">
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.sl_no}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Pagination: () => (
                                <Box className="al-pagination-bar" id="nir-pagination">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <FormControl variant="outlined" size="small" sx={{minWidth: 90}}>
                                            <MuiSelect
                                                value={pageSize}
                                                onChange={handlePageSizeChange}
                                                sx={{fontSize: '0.78rem', fontFamily: "'DM Sans', sans-serif"}}
                                            >
                                                {[10, 25, 50, 100, 200, 500].map((size) => (
                                                    <MenuItem key={size} value={size} sx={{fontSize: '0.78rem'}}>
                                                        {size}
                                                    </MenuItem>
                                                ))}
                                            </MuiSelect>
                                        </FormControl>
                                    </div>
                                    <Box sx={{color: '#64748b', fontSize: '0.78rem'}}>
                                        Showing <strong>{items.length}</strong> of <strong>{totalItems}</strong>
                                    </Box>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                        sx={{
                                            '& .Mui-selected': {
                                                backgroundColor: '#0e8aca !important',
                                                borderColor:     '#0e8aca !important',
                                                color:           '#fff !important',
                                            },
                                            '& .MuiButtonBase-root': {
                                                fontFamily: "'DM Sans', sans-serif",
                                                fontSize:   '0.76rem',
                                            },
                                        }}
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body, 'DM Sans', sans-serif)",
                            '& .MuiDataGrid-columnHeaders': {
                                background:    '#f8f9fc',
                                borderBottom:  '1px solid #e2e6ef',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight:    700,
                                fontSize:      '0.78rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                color:         '#1a3a5c',
                            },
                            '& .MuiDataGrid-sortIcon':          {color: 'rgba(26,58,92,0.7)'},
                            '& .MuiDataGrid-menuIconButton':    {color: 'rgba(26,58,92,0.7)'},
                            '& .MuiDataGrid-row':               {fontSize: '0.80rem'},
                            '& .MuiDataGrid-row:hover':         {backgroundColor: '#eef7fd'},
                            '& .MuiDataGrid-row.Mui-selected':  {backgroundColor: '#d8f0fa'},
                            '& .MuiDataGrid-cell':              {borderColor: '#f0f2f5'},
                            '& .MuiDataGrid-footerContainer':   {borderTop: '1px solid #e2e6ef', background: '#f8f9fc'},
                            '& .MuiDataGrid-virtualScroller':   {backgroundColor: '#fff'},
                        }}
                    />
                </Box>
            </div>

        </div>
    );
};

export default NotIdentifiableReport;